// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useTypologiesApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getTypologies = () => request("GET", `${API_STAGES_URL}/v1/typologies`)

  return [
    requestState,
    payload,
    error,
    {
      getTypologies,
    },
  ]
}

export default useTypologiesApi
